import React, { useEffect, useState } from "react";
import SideDrawer from "./SideDrawer";
import { reportApi } from "../../services/report";
import { toastMessage } from "../../utils/toastMessage";
import { LoadingButton } from "../header/form";

const ReportSideDrawer = ({ type, reportId, showDrawer, setShowDrawer }) => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState({});

  // OnChange handler
  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setReportData({ ...reportData, [name]: value });
  };

  const sendReportHandler = async () => {
    try {
      setLoading(true);
      const { data } = await reportApi({
        ...reportData,
        description: reportData?.title,
      });
      const { success, message, data: response } = data;
      toastMessage(
        "Report Submit Successfully",
        success ? "success" : "error",
        "reportHandler"
      );
      if (success) {
        setShowDrawer(false);
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setReportData({
      _report: reportId,
      title: "",
      description: "",
      type: type,
    });
  }, [reportId]);

  // console.log(reportData, "reportData");

  return (
    <SideDrawer show={showDrawer} handleClose={() => setShowDrawer(false)}>
      <div className="report_heading">
        <h2>Report Group</h2>

        <hr className="horizontal_line" />

        <p>
          Please provide a reason for reporting this group. Our team will review
          your report and take appropriate action if necessary.
        </p>
      </div>

      <div className="report_form">
        <div className="form_header">
          <h2 className="form_title">Select Reason</h2>
        </div>

        <form className="radio_group">
          <div className="radio_option">
            <input
              type="radio"
              id="inappropriate"
              name="title"
              value="inappropriate"
              checked={reportData?.title === "inappropriate"}
              onChange={inputChangeHandler}
            />
            <label for="inappropriate">Inappropriate Content</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="spam"
              name="title"
              value="spam"
              checked={reportData?.title === "spam"}
              onChange={inputChangeHandler}
            />
            <label for="spam">Spam or Scams</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="harassment"
              name="title"
              value="harassment"
              checked={reportData?.title === "harassment"}
              onChange={inputChangeHandler}
            />
            <label for="harassment">Harassment or Bullying</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="hate"
              name="title"
              value="hate"
              checked={reportData?.title === "hate"}
              onChange={inputChangeHandler}
            />
            <label for="hate">Hate Speech or Symbols</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="violence"
              name="title"
              value="violence"
              checked={reportData?.title === "violence"}
              onChange={inputChangeHandler}
            />
            <label for="violence">Violence or Harm</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="copyright"
              name="title"
              value="copyright"
              checked={reportData?.title === "copyright"}
              onChange={inputChangeHandler}
            />
            <label for="copyright">Copyright Violation</label>
          </div>

          <div className="radio_option">
            <input
              type="radio"
              id="other"
              name="title"
              value="other"
              checked={reportData?.title === "other"}
              onChange={inputChangeHandler}
            />
            <label for="other">Other</label>
          </div>
        </form>
        {reportData?.title === "other" && (
          <>
            <div className="form_header">
              <h2 className="form_title">Additional Comments</h2>
            </div>

            <div className="textarea_report">
              <textarea
                name="description"
                id="description"
                rows="6"
                cols="40"
                onChange={inputChangeHandler}
              />
            </div>
          </>
        )}

        <LoadingButton
          loading={loading}
          onClick={sendReportHandler}
          className="btn"
          type="submit"
          value="Submit"
        >
          Submit Report
        </LoadingButton>
      </div>
    </SideDrawer>
  );
};

export default ReportSideDrawer;
